import script from "./ProductHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductHeader.vue?vue&type=script&lang=ts&setup=true"

import "./ProductHeader.vue?vue&type=style&index=0&id=188fdfca&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-188fdfca"]])

export default __exports__